// @flow

import React from "react";

import EditableForm from "../../components/EditableForm";
import FormRow from "../../components/FormRow";
import EditableField from "../../components/EditableField";
import * as v from "../../utils/validators";
import * as formatters from "../../utils/formatters";
import { errors } from "../../utils/errors";
import { placeholders } from "../../utils/placeholders";

import {
  PURPOSE_KIND,
  SOFTWARE_PERIOD_OF_USE,
  SOFTWARE_MANUFACTURER,
  FEDERAL_STATE,
  SOFTWARE_DESCRIPTION
} from "./formFields";
import { mapPurposeKind, getKind } from "./mappers";

import { type InvestmentSectionProps } from "../../types/details";

const InvestmentHardAndSoftware = ({
  kind,
  initialValues,
  handleSubmit,
  isLocked
}: InvestmentSectionProps) => {
  return (
    <EditableForm initialValues={initialValues} onSubmit={handleSubmit} isLocked={isLocked}>
      <FormRow separator>
        <EditableField
          fieldControlProps={{
            name: PURPOSE_KIND,
            caption: () => "Investitionsvorhaben"
          }}
          displayValue={value => {
            const purposeKind = getKind(value, kind);
            return purposeKind && mapPurposeKind(purposeKind.kind);
          }}
        />
        <EditableField
          fieldControlProps={{
            name: FEDERAL_STATE,
            caption: () => "Investitionsort liegt in..."
          }}
        />
        <div />
      </FormRow>
      <FormRow>
        <EditableField
          fieldControlProps={{
            name: SOFTWARE_PERIOD_OF_USE,
            caption: () => "Gewöhnliche/geplante Nutzungsdauer",
            validate: v.combineWithPrefillCheck(
              errors.requiredField(),
              v.upperBound(999, errors.maxLengthDigits(3))
            )
          }}
          displayValue={formatters.formatYears}
          inputProps={{ placeholder: placeholders.inYears, separateThousands: false }}
          type="numberInput"
        />
        <EditableField
          fieldControlProps={{
            name: SOFTWARE_MANUFACTURER,
            caption: () => "Hersteller"
          }}
        />
        <EditableField
          fieldControlProps={{
            name: SOFTWARE_DESCRIPTION,
            caption: () => "Beschreibung",
            validate: v.combineWithPrefillCheck(
              errors.requiredField(),
              v.maxLength(500, errors.maxLengthCharacters(500))
            )
          }}
          type="textArea"
          inputProps={{
            placeholder: "Bitte differenzieren Sie Hard- und Software möglichst detailliert."
          }}
        />
      </FormRow>
    </EditableForm>
  );
};

export default InvestmentHardAndSoftware;
